import styled from "styled-components";

const Component = styled.div`
  ${(p) =>
    p.theme.standardComponent.marginBottom &&
    `margin-bottom: ${p.theme.standardComponent.marginBottom}${p.theme.standardComponent.marginUnit}`}
  ${(p) =>
    p.theme.standardComponent.marginLeft &&
    `margin-left: ${p.theme.standardComponent.marginLeft}${p.theme.standardComponent.marginUnit}`}
    ${(p) =>
    p.theme.standardComponent.marginRight &&
    `margin-right: ${p.theme.standardComponent.marginRight}${p.theme.standardComponent.marginUnit}`}
    ${(p) =>
    p.theme.standardComponent.marginTop &&
    `margin-top: ${p.theme.standardComponent.marginTop}${p.theme.standardComponent.marginUnit}`}
    
    ${(p) =>
    p.theme.standardComponent.paddingBottom &&
    `padding-bottom: ${p.theme.standardComponent.paddingBottom}${p.theme.standardComponent.paddingUnit}`}
    ${(p) =>
    p.theme.standardComponent.paddingLeft &&
    `padding-left: ${p.theme.standardComponent.paddingLeft}${p.theme.standardComponent.paddingUnit}`}
    ${(p) =>
    p.theme.standardComponent.paddingRight &&
    `padding-right: ${p.theme.standardComponent.paddingRight}${p.theme.standardComponent.paddingUnit}`}
    ${(p) =>
    p.theme.standardComponent.paddingTop &&
    `padding-top: ${p.theme.standardComponent.paddingTop}${p.theme.standardComponent.paddingUnit}`}
`;

export default Component;
